import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { ownerOnboardingKeys } from '../ownerOnboardingQueryKeys'
import { getSellerOwnerOnboardingAvailability } from '../ownerOnboardingEndpoints'

/**
 * Whether the signed-in seller can finish their own owner onboarding on this
 * request from the portal. The server decides — it matches the seller's
 * UAE-Pass-verified Emirates ID against the request's owners — so the portal
 * never guesses from `isPrimary`.
 *
 * `isEnabled` lets the request page ask only while the request is at owner
 * onboarding, instead of paying for a read on every status.
 */
export function useSellerOwnerOnboardingAvailabilityQuery(
  listingRequestId: MaybeRefOrGetter<string>,
  isEnabled: MaybeRefOrGetter<boolean>,
) {
  return useQuery({
    queryKey: ownerOnboardingKeys.sellerAvailability(toValue(listingRequestId)),
    queryFn: () => getSellerOwnerOnboardingAvailability(toValue(listingRequestId)),
    enabled: () => Boolean(toValue(listingRequestId)) && toValue(isEnabled),
  })
}
